export default "__VITE_ASSET__B8Q7DE5B__"